import styled from "styled-components"

export const LightText = styled.span`
  opacity: 0.7;
  padding-right: 5px;
  font-size: 11px;
`
